export const SET_MUSICIAN_STATUS = 'SET_MUSICIAN_STATUS';